module.exports = __webpack_public_path__ + "static/media/Asset 58.8e431b63.jpg";